import { Stack } from '@/components/layout/stack';
import { SvgIcon } from '@/components/ui';
import Text from '@/components/ui/text/text';
import { STRINGS } from '@/constants/strings';
import { useStyles } from '@/features/player/components/player-profile/player-equipment/styles';
import { useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

export function KitItem({
  level,
  dateText,
  coachName,
}: {
  level: number;
  dateText: string;
  coachName: string;
}) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack
      direction="row"
      gap={scale(16)}
      backgroundColor={'white'}
      paddingX={scale(8)}
      borderRadius={scale(4)}
      paddingY={scale(10)}
      style={styles.equipmentCard}>
      <Stack align="center" justify="center">
        <Stack
          align="center"
          justify="center"
          padding={scale(8)}
          borderRadius={8}
          backgroundColor={'#EAF0FF'}>
          <SvgIcon name="IcPackage" size={scale(24)} color={colors.Blue} />
        </Stack>
      </Stack>
      <Stack flex={1} justify="space-between">
        <Stack direction="row" justify="space-between" align="center">
          <Text
            variant="Font Montserrat/Subtitle/Minimize 2 Bold 10px"
            fontWeight={'800'}
            style={styles.levelText}>
            {STRINGS.player.profile.equipment.kitLevel(level)}
          </Text>
          <Text variant="Font Inter/Subtitle/Regular">{dateText}</Text>
        </Stack>
        <Stack>
          <Text variant="Font Inter/Subtitle/Regular 11px">
            {STRINGS.player.profile.equipment.by} <Text fontWeight={'800'}>{coachName}</Text>
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}
